 
import colors from 'vuetify/lib/util/colors'

export default {
  primary: {
    base: '#185ea9',
    darken1: colors.purple.darken2,
  },
  success: {
      base: '#4caf50',
      darken1: colors.purple.darken2,
  },
  worktimesecondary: '#B9CADD', 
  anchor: '#1976d2', 
  worktimetitle: '#185ea9',
  light: '#FEFEFE'
}